/** Generate by swagger-axios-codegen */
// @ts-nocheck
/* eslint-disable */

/** Generate by swagger-axios-codegen */
/* eslint-disable */
// @ts-nocheck
import { type AxiosInstance, type AxiosRequestConfig } from 'axios';

export interface IRequestOptions extends AxiosRequestConfig {
    /**
     * show loading status
     */
    loading?: boolean;
    /**
     * display error message
     */
    showError?: boolean;
    /**
     * data security, extended fields are encrypted using the specified algorithm
     */
    security?: Record<string, 'md5' | 'sha1' | 'aes' | 'des'>;
    /**
     * indicates whether Authorization credentials are required for the request
     * @default true
     */
    withAuthorization?: boolean;
}

export interface IRequestConfig {
    method?: any;
    headers?: any;
    url?: any;
    data?: any;
    params?: any;
}

// Add options interface
export interface ServiceOptions {
    axios?: AxiosInstance;
    /** only in axios interceptor config*/
    loading: boolean;
    showError: boolean;
}

// Add default options
export const serviceOptions: ServiceOptions = {};

// Instance selector
export function axios(configs: IRequestConfig, resolve: (p: any) => void, reject: (p: any) => void): Promise<any> {
    if (serviceOptions.axios) {
        return serviceOptions.axios
            .request(configs)
            .then((res) => {
                resolve(res.data);
            })
            .catch((err) => {
                reject(err);
            });
    } else {
        throw new Error('please inject yourself instance like axios  ');
    }
}

export function getConfigs(method: string, contentType: string, url: string, options: any): IRequestConfig {
    const configs: IRequestConfig = {
        loading: serviceOptions.loading,
        showError: serviceOptions.showError,
        ...options,
        method,
        url,
    };
    configs.headers = {
        ...options.headers,
        'Content-Type': contentType,
    };
    return configs;
}

export const basePath = '';

export interface IList<T> extends Array<T> {}
export interface List<T> extends Array<T> {}
export interface IDictionary<TValue> {
    [key: string]: TValue;
}
export interface Dictionary<TValue> extends IDictionary<TValue> {}

export interface IListResult<T> {
    items?: T[];
}

export class ListResultDto<T> implements IListResult<T> {
    items?: T[];
}

export interface IPagedResult<T> extends IListResult<T> {
    totalCount?: number;
    items?: T[];
}

export class PagedResultDto<T = any> implements IPagedResult<T> {
    totalCount?: number;
    items?: T[];
}

// customer definition
// empty

export class FilestoreService {
    /**
     *
     */
    static getFilestore(
        params: {
            /**  */
            guid: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<any> {
        return new Promise((resolve, reject) => {
            let url = basePath + '/{guid}';
            url = url.replace('{guid}', params['guid'] + '');

            const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

            axios(configs, resolve, reject);
        });
    }
    /**
     *
     */
    static deleteFile(
        params: {
            /**  */
            guid: string;
            /**  */
            parentId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<any> {
        return new Promise((resolve, reject) => {
            let url = basePath + '/{guid}';
            url = url.replace('{guid}', params['guid'] + '');

            const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
            configs.params = { parentId: params['parentId'] };

            axios(configs, resolve, reject);
        });
    }
    /**
     *
     */
    static renameFile(
        params: {
            /**  */
            guid: string;
            /** requestBody */
            body?: RenameFilestoreDto;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<any> {
        return new Promise((resolve, reject) => {
            let url = basePath + '/{guid}';
            url = url.replace('{guid}', params['guid'] + '');

            const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

            let data = params.body;

            configs.data = data;

            axios(configs, resolve, reject);
        });
    }
    /**
     *
     */
    static getFilestoresByParent(
        params: {
            /**  */
            parentId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<any> {
        return new Promise((resolve, reject) => {
            let url = basePath + '/';

            const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
            configs.params = { parent_id: params['parentId'] };

            axios(configs, resolve, reject);
        });
    }
    /**
     *
     */
    static getFile(
        params: {
            /**  */
            guid: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<any> {
        return new Promise((resolve, reject) => {
            let url = basePath + '/file/{guid}';
            url = url.replace('{guid}', params['guid'] + '');

            const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

            axios(configs, resolve, reject);
        });
    }
    /**
     *
     */
    static getFilePublic(
        params: {
            /**  */
            guid: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<any> {
        return new Promise((resolve, reject) => {
            let url = basePath + '/public/{token}/get/{guid}';
            url = url.replace('{guid}', params['guid'] + '');

            const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

            axios(configs, resolve, reject);
        });
    }
    /**
     *
     */
    static getFilePublic1(
        params: {
            /**  */
            guid: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<any> {
        return new Promise((resolve, reject) => {
            let url = basePath + '/public/{token}/get/{guid}/{file}';
            url = url.replace('{guid}', params['guid'] + '');

            const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

            axios(configs, resolve, reject);
        });
    }
    /**
     *
     */
    static getDirectFileByGuid(
        params: {
            /**  */
            guid: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<any> {
        return new Promise((resolve, reject) => {
            let url = basePath + '/direct-file-link/{guid}/{filename}';
            url = url.replace('{guid}', params['guid'] + '');

            const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

            axios(configs, resolve, reject);
        });
    }
    /**
     *
     */
    static saveFile(
        params: {
            /**  */
            file: any;
            /**  */
            name: string;
            /**  */
            description?: string;
            /**  */
            parentId?: string;
            /**  */
            guid?: string;
            /**  */
            expires?: string;
            /**  */
            mimetype?: string;
            /**  */
            isPublic?: boolean;
            /**  */
            isExtraSection?: boolean;
            /** requestBody */
            body?: FileInfoDto;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<any> {
        return new Promise((resolve, reject) => {
            let url = basePath + '/save';

            const configs: IRequestConfig = getConfigs('post', 'multipart/form-data', url, options);

            let data = params.body;
            data = new FormData();
            if (params['file'] != null) {
                if (Object.prototype.toString.call(params['file']) === '[object Array]') {
                    for (const item of params['file']) {
                        data.append('file', item as any);
                    }
                } else {
                    data.append('file', params['file'] as any);
                }
            }

            if (params['name'] != null) {
                if (Object.prototype.toString.call(params['name']) === '[object Array]') {
                    for (const item of params['name']) {
                        data.append('name', item as any);
                    }
                } else {
                    data.append('name', params['name'] as any);
                }
            }

            if (params['description'] != null) {
                if (Object.prototype.toString.call(params['description']) === '[object Array]') {
                    for (const item of params['description']) {
                        data.append('description', item as any);
                    }
                } else {
                    data.append('description', params['description'] as any);
                }
            }

            if (params['parentId'] != null) {
                if (Object.prototype.toString.call(params['parentId']) === '[object Array]') {
                    for (const item of params['parentId']) {
                        data.append('parent_id', item as any);
                    }
                } else {
                    data.append('parent_id', params['parentId'] as any);
                }
            }

            if (params['guid'] != null) {
                if (Object.prototype.toString.call(params['guid']) === '[object Array]') {
                    for (const item of params['guid']) {
                        data.append('guid', item as any);
                    }
                } else {
                    data.append('guid', params['guid'] as any);
                }
            }

            if (params['expires'] != null) {
                if (Object.prototype.toString.call(params['expires']) === '[object Array]') {
                    for (const item of params['expires']) {
                        data.append('expires', item as any);
                    }
                } else {
                    data.append('expires', params['expires'] as any);
                }
            }

            if (params['mimetype'] != null) {
                if (Object.prototype.toString.call(params['mimetype']) === '[object Array]') {
                    for (const item of params['mimetype']) {
                        data.append('mimetype', item as any);
                    }
                } else {
                    data.append('mimetype', params['mimetype'] as any);
                }
            }

            if (params['isPublic'] != null) {
                if (Object.prototype.toString.call(params['isPublic']) === '[object Array]') {
                    for (const item of params['isPublic']) {
                        data.append('is_public', item as any);
                    }
                } else {
                    data.append('is_public', params['isPublic'] as any);
                }
            }

            if (params['isExtraSection'] != null) {
                if (Object.prototype.toString.call(params['isExtraSection']) === '[object Array]') {
                    for (const item of params['isExtraSection']) {
                        data.append('is_extra_section', item as any);
                    }
                } else {
                    data.append('is_extra_section', params['isExtraSection'] as any);
                }
            }

            configs.data = data;

            axios(configs, resolve, reject);
        });
    }
    /**
     *
     */
    static copyLinks(
        params: {
            /** requestBody */
            body?: CopyLinksDto;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<any> {
        return new Promise((resolve, reject) => {
            let url = basePath + '/copy-links';

            const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

            let data = params.body;

            configs.data = data;

            axios(configs, resolve, reject);
        });
    }
    /**
     *
     */
    static restoreFile(
        params: {
            /**  */
            guid: string;
            /**  */
            parentId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<any> {
        return new Promise((resolve, reject) => {
            let url = basePath + '/{guid}/restore';
            url = url.replace('{guid}', params['guid'] + '');

            const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);
            configs.params = { parentId: params['parentId'] };

            axios(configs, resolve, reject);
        });
    }
    /**
     *
     */
    static assignToExtraSection(
        params: {
            /**  */
            guid: string;
            /** requestBody */
            body?: AssignExtraDto;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<any> {
        return new Promise((resolve, reject) => {
            let url = basePath + '/{guid}/assign-extra';
            url = url.replace('{guid}', params['guid'] + '');

            const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

            let data = params.body;

            configs.data = data;

            axios(configs, resolve, reject);
        });
    }
    /**
     *
     */
    static archiveFilesByInvoiceIds(
        params: {
            /** requestBody */
            body?: OptionsDownloadInvArchiveDto;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<any> {
        return new Promise((resolve, reject) => {
            let url = basePath + '/archive_invoice';

            const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

            let data = params.body;

            configs.data = data;

            axios(configs, resolve, reject);
        });
    }
    /**
     *
     */
    static archiveFilesByRegister(
        params: {
            /** requestBody */
            body?: OptionsDownloadRegisterArchiveDto;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<any> {
        return new Promise((resolve, reject) => {
            let url = basePath + '/archive_register';

            const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

            let data = params.body;

            configs.data = data;

            axios(configs, resolve, reject);
        });
    }
    /**
     *
     */
    static signArchiveFilesByRegisterDownload(
        params: {
            /** requestBody */
            body?: OptionsDownloadRegisterArchiveDto;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<ArchiveRegisterDownloadSignResponseDto> {
        return new Promise((resolve, reject) => {
            let url = basePath + '/archive_register/sign-download';

            const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

            let data = params.body;

            configs.data = data;

            axios(configs, resolve, reject);
        });
    }
    /**
     *
     */
    static checkHashes(
        params: {
            /** requestBody */
            body?: CheckFileHashesDto;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<any> {
        return new Promise((resolve, reject) => {
            let url = basePath + '/file-hash-check';

            const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

            let data = params.body;

            configs.data = data;

            axios(configs, resolve, reject);
        });
    }
    /**
     *
     */
    static recoverySave(
        params: {
            /**  */
            file: any;
            /**  */
            blobId: string;
            /**  */
            directory: string;
            /** requestBody */
            body?: FileRecoverySaveDto;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<any> {
        return new Promise((resolve, reject) => {
            let url = basePath + '/file-recovery-save';

            const configs: IRequestConfig = getConfigs('post', 'multipart/form-data', url, options);

            let data = params.body;
            data = new FormData();
            if (params['file'] != null) {
                if (Object.prototype.toString.call(params['file']) === '[object Array]') {
                    for (const item of params['file']) {
                        data.append('file', item as any);
                    }
                } else {
                    data.append('file', params['file'] as any);
                }
            }

            if (params['blobId'] != null) {
                if (Object.prototype.toString.call(params['blobId']) === '[object Array]') {
                    for (const item of params['blobId']) {
                        data.append('blob_id', item as any);
                    }
                } else {
                    data.append('blob_id', params['blobId'] as any);
                }
            }

            if (params['directory'] != null) {
                if (Object.prototype.toString.call(params['directory']) === '[object Array]') {
                    for (const item of params['directory']) {
                        data.append('directory', item as any);
                    }
                } else {
                    data.append('directory', params['directory'] as any);
                }
            }

            configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static recoveryReplaceFile(
    params: {
      /**  */
      file: any;
      /**  */
      blobId: string;
      /**  */
      hash: string;
      /** requestBody */
      body?: FileRecoveryReplaceSaveDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/file-recovery-replace-save';

      const configs: IRequestConfig = getConfigs('post', 'multipart/form-data', url, options);

      let data = params.body;
      data = new FormData();
      if (params['file'] != null) {
        if (Object.prototype.toString.call(params['file']) === '[object Array]') {
          for (const item of params['file']) {
            data.append('file', item as any);
          }
        } else {
          data.append('file', params['file'] as any);
        }
      }

      if (params['blobId'] != null) {
        if (Object.prototype.toString.call(params['blobId']) === '[object Array]') {
          for (const item of params['blobId']) {
            data.append('blobId', item as any);
          }
        } else {
          data.append('blobId', params['blobId'] as any);
        }
      }

      if (params['hash'] != null) {
        if (Object.prototype.toString.call(params['hash']) === '[object Array]') {
          for (const item of params['hash']) {
            data.append('hash', item as any);
          }
        } else {
          data.append('hash', params['hash'] as any);
        }
      }

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class FilestorePreviewService {
    /**
     *
     */
    static getCachedPreview(
        params: {
            /**  */
            filestoreId: string;
            /**  */
            apiKey: string;
            /**  */
            pageNum?: number;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<any> {
        return new Promise((resolve, reject) => {
            let url = basePath + '/preview/{filestore_id}/preview.png';
            url = url.replace('{filestore_id}', params['filestoreId'] + '');

            const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
            configs.params = { api_key: params['apiKey'], pageNum: params['pageNum'] };

            axios(configs, resolve, reject);
        });
    }
    /**
     *
     */
    static getCachedPreview1(
        params: {
            /**  */
            filestoreId: string;
            /**  */
            apiKey: string;
            /**  */
            pageNum?: number;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<any> {
        return new Promise((resolve, reject) => {
            let url = basePath + '/preview/{filestore_id}/preview.jpg';
            url = url.replace('{filestore_id}', params['filestoreId'] + '');

            const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
            configs.params = { api_key: params['apiKey'], pageNum: params['pageNum'] };

            axios(configs, resolve, reject);
        });
    }
    /**
     *
     */
    static precache(
        params: {
            /**  */
            filestoreId: string;
            /** requestBody */
            body?: FilestorePrecacheDto;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<PrecacheResponseDto> {
        return new Promise((resolve, reject) => {
            let url = basePath + '/preview/{filestore_id}/precache';
            url = url.replace('{filestore_id}', params['filestoreId'] + '');

            const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

            let data = params.body;

            configs.data = data;

            axios(configs, resolve, reject);
        });
    }
    /**
     *
     */
    static count(
        params: {
            /**  */
            filestoreId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<PreviewsCountResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + '/preview/{filestore_id}/count';
            url = url.replace('{filestore_id}', params['filestoreId'] + '');

            const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

            axios(configs, resolve, reject);
        });
    }
}

export class AuthService {
    /**
     *
     */
    static signForToken(
        params: {
            /** requestBody */
            body?: SignForTokenRequestDto;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<SignForTokenResponseDto> {
        return new Promise((resolve, reject) => {
            let url = basePath + '/auth/sign-for-token';

            const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

            let data = params.body;

            configs.data = data;

            axios(configs, resolve, reject);
        });
    }
}

export class UserAvatarService {
    /**
     *
     */
    static saveAvatar(
        params: {
            /**  */
            file: any;
            /**  */
            left: number;
            /**  */
            top: number;
            /**  */
            width: number;
            /**  */
            height: number;
            /** requestBody */
            body?: CreateUserAvatarDto;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<any> {
        return new Promise((resolve, reject) => {
            let url = basePath + '/user-avatar/create';

            const configs: IRequestConfig = getConfigs('post', 'multipart/form-data', url, options);

            let data = params.body;
            data = new FormData();
            if (params['file'] != null) {
                if (Object.prototype.toString.call(params['file']) === '[object Array]') {
                    for (const item of params['file']) {
                        data.append('file', item as any);
                    }
                } else {
                    data.append('file', params['file'] as any);
                }
            }

            if (params['left'] != null) {
                if (Object.prototype.toString.call(params['left']) === '[object Array]') {
                    for (const item of params['left']) {
                        data.append('left', item as any);
                    }
                } else {
                    data.append('left', params['left'] as any);
                }
            }

            if (params['top'] != null) {
                if (Object.prototype.toString.call(params['top']) === '[object Array]') {
                    for (const item of params['top']) {
                        data.append('top', item as any);
                    }
                } else {
                    data.append('top', params['top'] as any);
                }
            }

            if (params['width'] != null) {
                if (Object.prototype.toString.call(params['width']) === '[object Array]') {
                    for (const item of params['width']) {
                        data.append('width', item as any);
                    }
                } else {
                    data.append('width', params['width'] as any);
                }
            }

            if (params['height'] != null) {
                if (Object.prototype.toString.call(params['height']) === '[object Array]') {
                    for (const item of params['height']) {
                        data.append('height', item as any);
                    }
                } else {
                    data.append('height', params['height'] as any);
                }
            }

            configs.data = data;

            axios(configs, resolve, reject);
        });
    }
    /**
     *
     */
    static deleteAvatar(options: IRequestOptions = {}): Promise<boolean> {
        return new Promise((resolve, reject) => {
            let url = basePath + '/user-avatar/delete';

            const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

            axios(configs, resolve, reject);
        });
    }
    /**
     *
     */
    static getAvatar(
        params: {
            /**  */
            sysUserId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<any> {
        return new Promise((resolve, reject) => {
            let url = basePath + '/user-avatar/{sysUserId}/avatar/{field}';
            url = url.replace('{sysUserId}', params['sysUserId'] + '');

            const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

            axios(configs, resolve, reject);
        });
    }
    /**
     *
     */
    static isExistsAvatar(
        params: {
            /**  */
            sysUserId: string;
            /**  */
            field: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<boolean> {
        return new Promise((resolve, reject) => {
            let url = basePath + '/user-avatar/{sysUserId}/avatar-is-exists/{field}';
            url = url.replace('{sysUserId}', params['sysUserId'] + '');
            url = url.replace('{field}', params['field'] + '');

            const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

            axios(configs, resolve, reject);
        });
    }
}

export class PeriodicReportsService {
    /**
     *
     */
    static uploadReport(
        params: {
            /**  */
            id: string;
            /**  */
            file: any;
            /** requestBody */
            body?: UploadPeriodicReportDto;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<any> {
        return new Promise((resolve, reject) => {
            let url = basePath + '/periodic-reports/{id}/upload';
            url = url.replace('{id}', params['id'] + '');

            const configs: IRequestConfig = getConfigs('post', 'multipart/form-data', url, options);

            let data = params.body;
            data = new FormData();
            if (params['file'] != null) {
                if (Object.prototype.toString.call(params['file']) === '[object Array]') {
                    for (const item of params['file']) {
                        data.append('file', item as any);
                    }
                } else {
                    data.append('file', params['file'] as any);
                }
            }

            configs.data = data;

            axios(configs, resolve, reject);
        });
    }
    /**
     *
     */
    static getPreviewForHistoryItem(
        params: {
            /**  */
            id: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<any> {
        return new Promise((resolve, reject) => {
            let url = basePath + '/periodic-reports/{id}/history/preview.png';
            url = url.replace('{id}', params['id'] + '');

            const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

            axios(configs, resolve, reject);
        });
    }
}

export interface FileInfoDto {
    /**  */
    file: string;

    /**  */
    name: string;

    /**  */
    description?: string;

    /**  */
    parent_id?: string;

    /**  */
    guid?: string;

    /**  */
    expires?: string;

    /**  */
    mimetype?: string;

    /**  */
    is_public?: boolean;

    /**  */
    is_extra_section?: boolean;
}

export interface CopyLinksDto {
    /**  */
    parent_id: string;

    /**  */
    new_parent_id: object;
}

export interface RenameFilestoreDto {
    /**  */
    name: string;

    /**  */
    parent_id?: string;
}

export interface AssignExtraDto {
    /**  */
    isExtraSection: boolean;
}

export interface OptionsDownloadInvArchiveDto {
    /**  */
    invoice_ids: string[];

    /**  */
    download_contract: boolean;

    /**  */
    download_payment: boolean;

    /**  */
    sort: object;
}

export interface OptionsDownloadRegisterArchiveDto {
    /**  */
    register_type: 'invoice' | 'contract' | 'act';

    /**  */
    group_by_project?: boolean;

    /**  */
    download_extra?: boolean;

    /**  */
    download_payment?: boolean;

    /**  */
    year?: number;

    /**  */
    sort: 'document' | 'contragent' | 'mix';
}

export interface ArchiveRegisterDownloadSignResponseDto {
    /**  */
    token: string;
}

export interface CheckFileHashRequest {
    /**  */
    hash: string;

    /**  */
    size: number;
}

export interface CheckFileHashesDto {
    /**  */
    files: CheckFileHashRequest[];

    /**  */
    crossOrganizationEnabled?: boolean;

  /**  */
  sysServiceOrgLinkId?: string;

  /**  */
  other?: boolean;

  /**  */
  fileNameList?: string[];
}

export interface FileRecoverySaveDto {
    /**  */
    file: string;

    /**  */
    blob_id: string;

    /**  */
    directory: string;
}

export interface FileRecoveryReplaceSaveDto {
  /**  */
  file: string;

  /**  */
  blobId: string;

  /**  */
  hash: string;
}

export interface FilestorePrecacheDto {
    /**  */
    pagesCount: number;

    /**  */
    count?: number;
}

export interface PrecacheResponseDto {
    /**  */
    completed: number;

    /**  */
    error?: string;
}

export interface PreviewsCount1 {
    /**  */
    width: number;

    /**  */
    height: number;
}

export interface PreviewsCountResponse {
    /**  */
    pages: PreviewsCount1[];

    /**  */
    count: number;
}

export interface SignForTokenRequestDto {
    /**  */
    parent_id: string;
}

export interface SignForTokenResponseDto {
    /**  */
    token: string;
}

export interface CreateUserAvatarDto {
    /**  */
    file: string;

    /**  */
    left: number;

    /**  */
    top: number;

    /**  */
    width: number;

    /**  */
    height: number;
}

export interface UploadPeriodicReportDto {
    /**  */
    file: string;
}
